/**
 * View component for /answers
 *
 * Generic answer list view. Defaults to 'all' with:
 * this.props.dispatch(answerActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as answerActions from '../answerActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import answer components
import AnswerLayout from '../components/AnswerLayout.js.jsx';
import AnswerListItem from '../components/AnswerListItem.js.jsx';

// import answer css modules
import answerStyles from '../answerModuleStyles.css';

class AnswerList extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // fetch a list of your choice
    this.props.dispatch(answerActions.fetchListIfNeeded()); // defaults to 'all'
  }

  render() {
    const { answerStore } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the answerList meta info here so we can reference 'isFetching'
    const answerList = answerStore.lists ? answerStore.lists.all : null;

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual answer objetcs
     */
    const answerListItems = answerStore.util.getList("all");

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !answerListItems || !answerList;

    return (
      <AnswerLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> Answer List
                <Link className="yt-btn small u-pullRight" to={'/answers/new'}> NEW Answer </Link>
              </h1>
              <hr/>
              { isEmpty ?
                (answerListItems && answerList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: answerList.isFetching ? 0.5 : 1 }}>
                  <ul>
                    {answerListItems.map((answer, i) =>
                      <AnswerListItem key={answer._id + i} answer={answer} />
                    )}
                  </ul>
                </div>
              }
            </div>
          </section>
        </div>
      </AnswerLayout>
    )
  }
}

AnswerList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    answerStore: store.answer
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AnswerList)
);



// WEBPACK FOOTER //
// modules/answer/views/AnswerList.js.jsx